import React, { useState, useEffect } from 'react';

const offices = [
  {
    name: 'Warsaw Office (HQ)',
    address: 'Spektrum Tower, Twarda 18, 00-105 Warszawa',
    time: 'Mon - Sat 8.00 - 18.00.',
    phone: '+48 730 529 323'
  },
  {
    name: 'Gdańsk Office',
    address: 'Olivia Four, Al. Grunwaldzka 472 B, 80-309 Gdańsk',
    time: 'Mon - Sat 7.00 - 15.00.',
    phone: '+48 509 176 910'
  },
  {
    name: 'Wrocław Office',
    address: 'Green2Day, Szczytnicka 11, 50-382 Wrocław',
    time: 'Mon - Sat 7.00 - 15.00.',
    phone: '+48 509 176 910'
  },
  {
    name: 'Prague Office',
    address: 'Green2Day, Szczytnicka 11, 50-382 Wrocław',
    time: 'Mon - Sat 7.00 - 15.00.',
    phone: '+48 509 176 910'
  },
  {
    name: 'Brno Office',
    address: 'Hybešova 42 60200, Brno',
    time: 'Mon - Sat 8.00 - 16.00.',
    phone: '+420 775975538'
  },
  {
    name: 'Ostrava Office',
    address: '28. Října 3346/91 702 00, Ostrava',
    time: 'Mon - Sat 8.00 - 16.00.',
    phone: '+420 775975538'
  },
  {
    name: 'Bratislava Office',
    address: 'Nivy Tower, Mlynské Nivy 5, 811 09 Bratislava',
    time: 'Mon - Sat 8.00 - 15.00.',
    phone: '+421 918989358'
  },
  {
    name: 'Kosice Office',
    address: 'EcoPoint II, Magnezitárska 2/B, 040 13 Košice',
    time: 'Mon - Sat 8.00 - 18.00.',
    phone: '+421 905312206'
  },
  {
    name: 'Sofia Office',
    address: 'Uniqa Business Center 18, Todor Aleksandrov blvd, 1303 Sofia',
    time: 'Mon - Sat 7.00 - 15.00.',
    phone: '+359 895 522 944'
  }
];

const OfficesList = ({ setOffice }) => {
  const [activeOffice, setActiveOffice] = useState(0);

  useEffect(() => {
    setOffice(offices[activeOffice]);
    // eslint-disable-next-line
  }, [activeOffice]);

  return (
    <>
      <button className="btn btn-secondary dropdown-toggle" type="button" id="officeSelectDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        {offices[activeOffice].name}
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="officeSelectDropdown">
        {offices.map((office, index) => {
          return (
            <li key={index}>
              <button className="dropdown-item" type="button" onClick={() => setActiveOffice(index)}>
                {office?.name}
              </button>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default OfficesList;
